export default __webpack_public_path__ + "static/media/feathers.68e6d4c6.jpg";